import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Button, Modal, Input} from 'reactstrap';
import { Expander } from '../../../../../components/Common/Expander';
import { SearchBar } from '../../../../../components/Common/SearchBar';
import Table1 from "../../../../../components/Common/TableContainer";
import TableNP from "../../../../../components/Common/TableContainerNP";
import { getLabTests, getNorms, getLabAreas } from '../../../../../store/actions';
import { BaseCustomButton, BaseCustomModal, BaseSelectComponent, GradientDecorationLine } from '../../../../../shared';

export const NewRegisterEssayModal = ({ props, laboratoryType, setShowModal, showModal, modalRespInfo }) => {
    const [searchData, setSearchData] = useState('');
    const [rowTestIds, setRowTestIds] = useState([]);

    const [normaSelected, setNormaSelected] = useState(''); // Store selected Norma
    const [areaSelected, setAreaSelected] = useState(''); // Store selected Área de Laboratorio

    const [check, setCheck] = useState();
    const [checkID, setCheckID] = useState();

    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10); // default value for limit

    const dispatch = useDispatch();

    useEffect(() => {
        if (laboratoryType) {
            dispatch(getLabTests(`?limit=20&page=0&recordStatus=enable&laboratoryType=${laboratoryType}`));
        }
        dispatch(getLabAreas("?limit=4000&page=0"))
        dispatch(getNorms("?limit=4000&page=0"))
    }, [])

    const { labTests, loading, labTest, total, currentPage, norms, labAreas  } = useSelector(state => ({
        labTests: state.labTest.labTests,
        loading: state.labTest.loading,
        labTest: state.labTest.labTest,
        total: state.labTest.total,
        currentPage: state.labTest.currentPage,
        norms: state.norms.norms,
        labAreas: state.labAreas.labareas,

        labTestSamples: state.labTestSamples.labTestSamples,
    }), shallowEqual);
    // * Redux fin

    const toggle = () => {
        resetModalState();
        setShowModal(false);
    };      
    
    const onClosed = () => {
        resetModalState();
    };

    useEffect(() => {
        setPage(0); // Take the user to the first page when the limit value changes
    }, [searchData, areaSelected, normaSelected]);
    
    useEffect(() => {
        if (laboratoryType) {
            const labAreaParam = areaSelected ? `&laboratoryArea=${areaSelected}` : '';
            const normParam = normaSelected ? `&norm=${normaSelected}` : '';
            dispatch(getLabTests(`?limit=${limit}&page=${page}&recordStatus=enable&search=${searchData}&laboratoryType=${laboratoryType}${normParam}${labAreaParam}`));
        }
    }, [page, limit, laboratoryType, searchData, areaSelected, normaSelected]);

    const { className } = props;

    useEffect(() => {
        setRowTestIds(rowTestIds.map((element) => {
            if (element.id === checkID) {
                return {
                    id: checkID,
                    checkStatus: check,
                }
            } else {
                return element;
            }
        }))
    }, [rowTestIds.length])

    const onSelected = (value, checkStatus) => {

        setRowTestIds(rowTestIds => [
            ...rowTestIds,
            {
                id: value, // value: 'UUID'
                checkStatus: checkStatus,
            }
        ]);

        setCheck(checkStatus);
        setCheckID(value)
    }

    const submit = () => {

        let filteredArray;
        let filteredArrayAux;
        let deletedRepeatedElementsArray;

        filteredArray = rowTestIds.filter(rowTestId => rowTestId.checkStatus === true);
        filteredArrayAux = filteredArray.map((item) => item.id);
        deletedRepeatedElementsArray = filteredArrayAux.filter((item, index) => {
            return filteredArrayAux.indexOf(item) === index;
        })

        if (deletedRepeatedElementsArray.length > 0) {
            modalRespInfo(deletedRepeatedElementsArray);
            resetModalState();
            setShowModal(false);
        }
    }

    const resetModalState = () => {
        setSearchData('');
        setRowTestIds([]);
        setNormaSelected('');
        setAreaSelected('');
        setPage(0);
        setLimit(10);
    };      

    const columns = React.useMemo(
        () => [
            Expander,
            {
                Header: 'Norma',
                width: '25%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.norm?.name ?? '-'}</div>
                ),
            },
            {
                Header: 'Método',
                accessor: 'method',
                width: '20%',
            },
            {
                Header: 'Nombre del ensayo',
                accessor: 'name',
                width: '25%',
            },
            {
                Header: 'Área de Laboratorio',
                width: '20%',
                Cell: ({ row }) => (
                    <div className='text-left'>{row.original.laboratoryArea?.name ?? '-'}</div>
                ),
            },
            {
                width: '5%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="d-flex justify-content-center">
                        <input
                        className="form-check-input rounded-pill p-3"
                        type="checkbox"
                        id="checkboxNoLabel"
                        onClick={(e) => onSelected(row.original.id, e.target.checked)}
                        />
                    </div>
                ),
            },
        ],
        []
    )

    const columns2 = React.useMemo(
        () => [
            {
                Header: 'Descripción de la muestra',
                // accessor: 'infoLab',
                width: '20%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.description ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Cantidad',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.quantity ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Unidad de Medida',
                width: "16%",
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.unitMeasure?.name ?? '-'}</div>
                    </div>
                ),
            },
        ],
        []
    )

    const getPagination = (params) => {
        const urlParams = new URLSearchParams(params);
        const newLimit = Number(urlParams.get('limit') ?? 10);
        const newPage = Number(urlParams.get('page') ?? 0);
    
        // if the user changed the limit, go to the first page
        if (newLimit !== limit) {
            setPage(0);
        } else {
            setPage(newPage);
        }
        setLimit(newLimit);
    };

    const callback = React.useCallback(
        ({ row }) => (
            <TableNP isAddTableBorderStrap columns={columns2} data={row.original.labTestsSamples ?? []} />
        ),
        []
    )

    const children_table = (
        <div>
            <SearchBar setSearchData={setSearchData} />

            <GradientDecorationLine />
    
            <div className="row">
                <div className="col-6">
                    <label>Norma</label>
                    <BaseSelectComponent
                        options={norms.map(norm => ({ value: norm.id, label: norm.name }))}
                        value={normaSelected}
                        onChange={setNormaSelected}
                        placeholder="Seleccionar Norma"
                    />
                </div>
    
                <div className="col-6">
                    <label>Área de Laboratorio</label>
                    <BaseSelectComponent
                        options={labAreas.map(area => ({ value: area.id, label: area.name }))}
                        value={areaSelected}
                        onChange={setAreaSelected}
                        placeholder="Seleccionar Área"
                    />
                </div>
            </div>
    
            <div className="px-0 py-2">
                <Table1
                    renderRowSubComponent={callback}
                    currentPage={page}
                    getPagination={getPagination}
                    total={total}
                    loading={loading}
                    isAddTableBorderStrap
                    columns={columns}
                    data={labTests}
                    limit={limit}
                />
            </div>
            <GradientDecorationLine />
        </div>
    );

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
            <BaseCustomButton
                color="success"
                label="Guardar"
                onClick={submit}
                outline
                className="rounded-3 me-3 p-2"
                icon="mdi mdi-content-save me-1"
            />
            <BaseCustomButton
                color="danger"
                label="Cancelar"
                onClick={toggle}
                outline
                className="rounded-3 p-2"
                icon="mdi mdi-close-circle me-1"
            />
        </div>
    );

    return (
        <>
            <BaseCustomModal
                title="Registro de ensayos"
                isModalOpen={showModal}
                handleOk={submit}
                handleCancel={toggle}
                onClosed={onClosed}
                children={children_table}
                width="80%" 
                centered
                style={{ overflowY: 'auto' }}
                footer={buttons}
            />
        </>
    )
}